import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ConnectedRouter as Router } from 'connected-react-router';
import { Provider } from 'react-redux';

import AppComponent from './Containers/App/AppComponent';
// import * as serviceWorker from './serviceWorker';
import configureStore from './Store/ConfigureStore';
import configureWebFontService from './Services/WebFontService';

import { getTenantCode } from './Utils/tenantUtils';
import { getClientAssets } from './Config/clientAssets';
import { initializeTenantConfig, setClientAssets } from './Store/Actions/TenantActions';

const { store, history } = configureStore();

// eslint-disable-next-line no-console
console.log(`${process.env.PROJECT_VERSION}:${process.env.REACT_APP_ENV}`);

configureWebFontService();

// Always get client assets, using default-coffeebeans if tenantCode is null
const tenantCode = getTenantCode();
const assets = getClientAssets(tenantCode);
store.dispatch(setClientAssets(assets));
store.dispatch(initializeTenantConfig(tenantCode));

ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID}>
      <Router history={history}>
        <AppComponent />
      </Router>
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('root')
);

// serviceWorker.register();
